import React, { useEffect, useState } from 'react'
import { Col, Row, FormGroup, Alert, Input } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'
import { isNotNumericDecimal } from 'context/Utilities'
import { flavorOptions } from './constants'
import Select from 'react-select'

const InstantOatmealPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    OatType: item.OatType,
    Flavor: item.Flavor,
    Size: item.Size,
  })
  const methods = useFormContext()
  const { onChangeReviewer, setSelectReviewer, asterisk } = useFormUtils()
  useEffect(() => {
    if (item !== null) {
      const { OatType, Flavor, Size } = item
      setPackaging({
        OatType,
        Flavor,
        Size,
      })
    }
    // eslint-disable-next-line
    }, [item])

  return (
    <>
      <Row>
        <Col xs={4}>
          <FormGroup>
            <p>
              <strong>Oat Type {asterisk}</strong>
            </p>
            <Input defaultValue={packaging.OatType} disabled />
          </FormGroup>
        </Col>
        <Col xs={4}>
          <FormGroup>
            <p>
              <strong>Flavor {asterisk}</strong>
            </p>
            <Controller
              as={Select}
              className="react-select primary"
              classNamePrefix="react-select"
              options={flavorOptions}
              defaultValue={{
                label: packaging.Flavor,
                value: packaging.Flavor,
              }}
              name="Flavor"
              control={methods.control}
              rules={{ required: true }}
              placeholder={'Select Oat Flavor'}
              onChange={([selected, value]) => {
                setSelectReviewer(item, selected, value)
                return selected
              }}
              isDisabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="Flavor"
                message={'⚠ Please select a flavor.'}
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        </Col>
        <Col xs={4}>
          <FormGroup>
            <p>
              <strong>Size {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="Size"
              type="number"
              step="0.01"
              placeholder={'11.8 - 12 ounces'}
              defaultValue={packaging.Size}
              onKeyDown={e => {
                if (isNotNumericDecimal(e.key)) {
                  e.preventDefault()
                }
              }}
              control={methods.control}
              rules={{
                maxLength: {
                  value: 6,
                  message: '⚠ Size exceeds 6 characters.',
                },
                min: {
                  value: 11.8,
                  message: '⚠ Size must be between 11.8 - 12 ounces.',
                },
                max: {
                  value: 12,
                  message: '⚠ Size must be between 11.8 - 12 ounces.',
                },
                required: {
                  value: true,
                  message: '⚠ Please enter product size.',
                },
                pattern: {
                  value: /^\d+(\.\d{1,2})?$/,
                  message: '⚠ Maximum two decimal places allowed.',
                },
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="Size"
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        </Col>
      </Row>
    </>
  )
}

InstantOatmealPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default InstantOatmealPackageReview
